<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form id="formValidate">
                <div class="element-info">
                  <div class="element-info-with-icon">
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Mtto/Servicio a Activo
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <ActivoFijoSelectComponent
                    :current="current"
                    :disabled="current.id != null"
                  />
                </div>

                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errors.estado && errors.tipo.length > 0,
                    }"
                    >Tipo</label
                  >
                  <select
                    class="form-control"
                    v-model="current.tipo"
                    placeholder="Tipo"
                    type="text"
                    v-bind:class="{
                      'is-invalid': errors.tipo && errors.tipo.length > 0,
                    }"
                  >
                    <option value="S">Servicio</option>
                    <option value="C">Combustible</option>
                    <option value="M">Mantenimiento</option>
                    <option value="R">Reparacion</option>
                  </select>
                  <small
                    v-if="errors.tipo && errors.tipo"
                    class="form-text text-danger"
                    >{{ errors.tipo[0] }}</small
                  >
                </div>

                <div class="row">
                  <div class="col-8">
                    <ProveedoresSelectComponent
                      :current="current"
                      :disabled="current.id != null"
                    />
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.fecha_servicio &&
                            errors.fecha_servicio.length > 0,
                        }"
                        >Fecha Servicio</label
                      >
                      <input
                        v-model="current.fecha_servicio"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Fecha Servicio"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.fecha_servicio &&
                            errors.fecha_servicio.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.fecha_servicio && errors.fecha_servicio"
                        class="form-text text-danger"
                        >{{ errors.fecha_servicio[0] }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.mecanico && errors.mecanico.length > 0,
                        }"
                        >Mecanico</label
                      >
                      <input
                        v-model="current.mecanico"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Mecanico"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.mecanico && errors.mecanico.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.mecanico && errors.mecanico"
                        class="form-text text-danger"
                        >{{ errors.mecanico[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.km_actual && errors.km_actual.length > 0,
                        }"
                        >Km Actuales</label
                      >
                      <input
                        v-model="current.km_actual"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Km Actuales"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.km_actual && errors.km_actual.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.km_actual && errors.km_actual"
                        class="form-text text-danger"
                        >{{ errors.km_actual[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.km_proximo_servicio &&
                            errors.km_proximo_servicio.length > 0,
                        }"
                        >Km Prox Servicio</label
                      >
                      <input
                        v-model="current.km_proximo_servicio"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Km Prox Servicio"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.km_proximo_servicio &&
                            errors.km_proximo_servicio.length > 0,
                        }"
                      />
                      <small
                        v-if="
                          errors.km_proximo_servicio &&
                            errors.km_proximo_servicio
                        "
                        class="form-text text-danger"
                        >{{ errors.km_proximo_servicio[0] }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        errors.descripcion && errors.descripcion.length > 0,
                    }"
                    >Descripción</label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="current.descripcion"
                    autofocus="autofocus"
                    placeholder="Descripción"
                    v-bind:class="{
                      'is-invalid':
                        errors.descripcion && errors.descripcion.length > 0,
                    }"
                  >
                  </textarea>
                  <small
                    v-if="errors.descripcion && errors.descripcion"
                    class="form-text text-danger"
                    >{{ errors.descripcion[0] }}</small
                  >
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.fact_documento &&
                            errors.fact_documento.length > 0,
                        }"
                        >Serie/Número Factura</label
                      >
                      <input
                        v-model="current.fact_documento"
                        class="form-control"
                        placeholder="Serie/Número Factura"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.fact_documento &&
                            errors.fact_documento.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.fact_documento && errors.fact_documento"
                        class="form-text text-danger"
                        >{{ errors.fact_documento[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.costo_total && errors.costo_total.length > 0,
                        }"
                        >Costo Total</label
                      >
                      <input
                        v-model="current.costo_total"
                        class="form-control"
                        placeholder="Costo Total"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.costo_total && errors.costo_total.length > 0,
                        }"
                      />
                      <small
                        v-if="errors.costo_total && errors.costo_total"
                        class="form-text text-danger"
                        >{{ errors.costo_total[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            errors.cxp_tipo_cargo &&
                            errors.cxp_tipo_cargo.length > 0,
                        }"
                        >Forma Pago</label
                      >
                      <select
                        v-model="current.cxp_tipo_cargo"
                        class="form-control"
                        placeholder="Forma Pago"
                        type="text"
                        v-bind:class="{
                          'is-invalid':
                            errors.cxp_tipo_cargo &&
                            errors.cxp_tipo_cargo.length > 0,
                        }"
                      >
                        <option value="CC">CC - CAJA CHICA</option>
                        <option value="FACT">FACT - FACTURA</option>
                      </select>
                      <small
                        v-if="errors.cxp_tipo_cargo && errors.cxp_tipo_cargo"
                        class="form-text text-danger"
                        >{{ errors.cxp_tipo_cargo[0] }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button
                    class="btn btn-primary"
                    type="button"
                    @click="guardar"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import ActivoFijoSelectComponent from "@/components/commons/ActivoFijoSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    ActivoFijoSelectComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      file: "",
      current: {},
      errors: {
        id: null,
        tipo_str: null,
        fecha_creacion: null,
        tipo: null,
        numero: null,
        fecha_servicio: null,
        km_proximo_servicio: null,
        descripcion: null,
        mecanico: null,
        costo_total: null,
        km_actual: null,
        fact_documento: null,
        anulado: null,
        activo: null,
        proveedor: null,
        cxp_tipo_cargo: null,
        cuenta_bancaria: null,
        cxp_cargo_d: null,
        solicitud_mtto: null,
      },
      data: [],
      grupos: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshData();
    }
  },

  methods: {
    guardar() {
      let self = this;

      let current = Object.assign({}, self.current);
      current.activo = self.current.activo.id;
      DynamicService.save("af", "mtto", current)
        .then((res) => {
          self.current.pk = res.data.id;
          self.current.id = res.data.id;
          Notifications.alert.success(
            "Activo Fijo",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "af-mttos-editar",
            params: { id: self.current.id },
          });
          self.refreshData();
        })
        .catch((error) => {
          console.log(error);
          self.current.errors = Object.assign(
            self.current.errors,
            error.response.data
          );
          console.log(self.errors);
          if ("detail" in error.response.data) {
            Notifications.alert.error("Error", error.response.data.detail);
          }
        });
    },

    refreshData() {
      let self = this;
      DynamicService.getById("af", "mtto", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.activo = self.current.activo_obj;
          self.current.pk = self.current.id;
          for (var key in self.current) {
            self.errors[key] = [];
          }
        }
      );
    },
  },
};
</script>
